import { createContext, useContext } from "react";

type WindowRenderMode = "full" | "contentOnly";

export const WindowRenderModeContext = createContext<WindowRenderMode>("full");

export function useWindowRenderMode(): WindowRenderMode {
    return useContext(WindowRenderModeContext);
}
